import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "../styles/discontinuationBanner.css";

const HCP_USER_TYPE = "User"; // userType of practitioners (see route_constants.js)

export const shouldShowDiscontinuationBanner = ({
  isAuth,
  userType,
  isStaff,
  country,
}) =>
  Boolean(isAuth) &&
  userType === HCP_USER_TYPE &&
  !isStaff &&
  (country === "US" || country === "CA");

export const useShowDiscontinuationBanner = () => {
  const auth = useSelector((state) => state.auth);
  return shouldShowDiscontinuationBanner(auth);
};

function DiscontinuationBanner() {
  const { t } = useTranslation();
  const show = useShowDiscontinuationBanner();
  if (!show) return null;
  return (
    <div className="discontinuation-banner" role="alert">
      {t("discontinue_banner_txt")}
    </div>
  );
}

export default DiscontinuationBanner;
